import { loadingButtonClasses } from "@mui/lab/LoadingButton";
import { buttonClasses } from "@mui/material/Button";

// ----------------------------------------------------------------------

export default function LoadingButton(theme) {
    return {
        MuiLoadingButton: {
            styleOverrides: {
                root: ({ ownerState }) => ( {
                    ...( ownerState.variant === "soft" && {
                        [`& .${loadingButtonClasses.loadingIndicatorStart}`]: {
                            left: 10
                        },
                        [`& .${loadingButtonClasses.loadingIndicatorEnd}`]: {
                            right: 14
                        },
                        ...( ownerState.size === "small" && {
                            [`& .${loadingButtonClasses.loadingIndicatorStart}`]: {
                                left: 10
                            },
                            [`& .${loadingButtonClasses.loadingIndicatorEnd}`]: {
                                right: 10
                            }
                        } )
                    } ),
                    [`&.${buttonClasses.disabled}`]: {
                        // color: "white",
                        // backgroundColor: theme.palette.action.disabledBackground,
                        cursor: "not-allowed",
                        color: theme.palette.text.tertiary,
                        borderColor: theme.palette.line,
                        backgroundColor: theme.palette.line
                    }
                } )
            }
        }
    };
}
